export const TimeConverter2 = (date: string | Date) => {
  if (!date) return "";

  const formattedDate = new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return formattedDate;
};